// NOTE: Dependencies: jQuery, Defiant

(function($) {
	$.fn.tooltip = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body'),
			closeBtn: 'tooltip-close-btn'
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		// Bind events
		methods.events = function() {

			$(document).on('click', '.' + settings.closeBtn, function() {
				$context.tipso('close');
			});
		}

		methods.initContext = function() {
			methods.setCurrentSettings();
			var tooltipTitle = '<div class="' + settings.closeBtn + '"></div>' + $context.data('tooltip-title'),
					tooltipContent = $context.data('tooltip-content'),
					maxWidth = '0',
					width = '100%',
					offsetX = -10;

			if (!$('html').hasClass('is-mobile')) {
				maxWidth = '300px';
				width = '';
				offsetX = 0;
			}

			// Intialising tooltip
			$context.tipso({
				speed             : 200,
				background        : '#000000',
				titleBackground   : '#000000',
				color             : '#ffffff',
				titleColor        : '#ffffff',
				titleContent      : tooltipTitle,
				showArrow         : true,
				position          : 'top',
				width             : width,
				maxWidth          : maxWidth,
				delay             : 50,
				hideDelay         : 0,
				animationIn       : '',
				animationOut      : '',
				offsetX           : offsetX,
				offsetY           : 0,
				tooltipHover      : true,
				content           : tooltipContent,
				ajaxContentUrl    : null,
				contentElementId  : null,
				useTitle          : false,
				templateEngineFunc: null,
				onShow            : null,
				onHide            : null
			});
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));

			// Run once methods when jquery plugin is called.
			methods.events(this);
		});
	};

	if ($('.tooltip').length) {
		$('.tooltip').tooltip();
	}

}(jQuery));
